export default __webpack_public_path__ + "static/media/status_success.017ea2e3.svg";